"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrderHistory = void 0;

var _react = require("react");

var _reactQuery = require("react-query");

var _api = require("../api");

var _context = require("../context");

var _types = require("../types");

var _useAuthenticated = require("./useAuthenticated");

var useOrderHistory = function useOrderHistory() {
  var isAuthenticated = (0, _useAuthenticated.useAuthenticated)();
  var context = (0, _react.useContext)(_context.AuthContext);
  /* istanbul ignore next */

  if (!context) {
    throw new Error('useOrderHistory must be used within an AuthProvider');
  }

  return (0, _reactQuery.useQuery)(_types.QueryKeys.OrderHistory, function () {
    return (0, _api.fetchOrderHistory)();
  }, {
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 20 * 60000
  });
};

exports.useOrderHistory = useOrderHistory;